<div class="label-list-menu-container">
	<au-native-input
		placeholder="{{ 'quick_search' | translate }}..."
		(inputChanged)="searchText.set($event)"
	/>

	@for (label of labels() | labelQuickSearch: searchText(); let i = $index; track i) {
		<mat-checkbox
			color="primary"
			class="au-checkbox"
			[ngClass]="i === index() && openedFromActionCenter ? 'active' : 'inactive'"
			[checked]="isChecked(label)"
			(change)="toggleSelection($event.checked, label)"
		>
			<label-badge [label]="label" [showCloseButton]="false" />
		</mat-checkbox>
	}
</div>
